import React from 'react'
import { EMPTY, REPORTS, SYSTEM_NAME1, SYSTEM_NAME2, SYSTEM_NAME3, SYSTEM_NAME5 } from './Constants';

export default function OEIDropdown(props) {
    return (
<div className="oe-form-field">
  <label className="oe-form-field__title" >{props.name}</label>
  <select className="oe-form-field__control" value={props.selectedValue} onChange={e=>{props.setSelectedValue(e);props.setMessage(EMPTY)}}>
            <option value={SYSTEM_NAME1}>{'OE Central'}</option>
            <option value={SYSTEM_NAME2}>{SYSTEM_NAME2}</option>
            <option value={SYSTEM_NAME3}>{SYSTEM_NAME3}</option>
            <option value={SYSTEM_NAME5}>{REPORTS}</option>
  </select>
  { props.errorMessage!==EMPTY?
 <div className="oe-form-field__error">{props.errorMessage}</div>
 :EMPTY
}


</div>    )
}
